/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { usePaymentService } from "../../../services/paymentService.js";
import { useNotificationContext } from "../../../contexts/notificationContext";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import Footer from "./footer";
import { ReactComponent as CardIcon} from "../../../resources/images/credit-card-03.svg";
import {useUserContext} from "../../../contexts/userContext";

/* Styles */
import styles from "./styles";

const ChangePaymentModal = ({showModal, setShowModal, callback, getCardIcon, getCardText, getExpiryDateText, paymentMethods, teamId, payments, maxCardsAssignment}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const { updateTeamPaymentMethod } = usePaymentService();
  const { setNotification } = useNotificationContext();
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const [paymentsMethodDetails, setPaymentsMethodDetails] = useState(payments || []);

  useEffect(() => {
    setPaymentsMethodDetails(payments)
  }, [payments]);

  const handleSaveModal = async () => {
    // if(payments !== paymentsMethodDetails) {
      const idsArray = paymentsMethodDetails.map(group => group.fopUUID);

      let reqBody = {
        groupEntityID: teamId,
        fopUUIDRefIds: idsArray
      }
      const success = await updateTeamPaymentMethod(reqBody)
      if(success) {
        setShowModal(false)
        callback(paymentsMethodDetails)
      }
    // }
    // else {
    //   setShowModal(false)
    //   setNotification(
    //     "success",
    //     <FormattedMessage id="notification.changePaymentSuccessTitle" />,
    //     <FormattedMessage id="notification.changePaymentSuccessText"/>
    //   )
    // }
  }

  return (
    <UCModal
      className={classes.changePaymentModal}
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ <CardIcon /> }
      modalTitle={ <FormattedMessage id={`changePaymentModal.title.${providerCode}`} /> }
      modalDescription={ <FormattedMessage id={`changePaymentModal.description.${providerCode}`} /> }
      modalContent={ <Content paymentsMethodDetails={paymentsMethodDetails} setPaymentsMethodDetails={setPaymentsMethodDetails} getCardIcon={getCardIcon} getCardText={getCardText} getExpiryDateText={getExpiryDateText} paymentMethods={paymentMethods} maxCardsAssignment={maxCardsAssignment} /> }
      modalFooter={ <Footer setShowModal={setShowModal} handleSaveModal={handleSaveModal} providerCode={providerCode}/> }
      dataTestId="changepaymentmodal"
      onExited={() => setPaymentsMethodDetails(payments)}
    />
  )
}

export default ChangePaymentModal;
